import { Outlet } from "react-router-dom";
import Sidebar from "@/components/Sidebar";
import Breadcrumb from "@/components/Breadcrumb";
import { useLocation } from "react-router-dom";
/**
 * DashboardLayout Component
 * ------------------------------------------------------------
 * Layout wrapper for authenticated/protected pages.
 * Provides a full application shell with:
 * - Sidebar navigation (left).
 * - Breadcrumb navigation (top).
 * - Main content area (dynamic via <Outlet />).
 *
 * Features:
 * - Persistent sidebar for navigation.
 * - Responsive layout with full viewport height.
 * - Scrollable main content area.
 *
 */
const DashboardLayout = () => {
  const location = useLocation();

  const isConfiguratorOpen =
    location.pathname.includes("/tenants/campaigns/experiences/edit") ||
    location.pathname.includes("/tenants/application-onboarding/edit");
  return (
    <div className="flex h-screen bg-gray-50">
      {/* ---------------- Sidebar Navigation ---------------- */}
      <Sidebar isHidden={isConfiguratorOpen} />

      {/* ---------------- Main Content Area ---------------- */}
      <div className="flex-1 flex flex-col overflow-hidden">
        <main className="flex-1 overflow-x-hidden overflow-y-auto bg-[linear-gradient(135deg,#002D3D_0%,#111A3D_48%,#332D62_100%)]">
          <div className="max-w-full mx-auto">
            {/* Breadcrumb navigation (without padding) */}
            {/* <Breadcrumb /> */}
            {!isConfiguratorOpen && <Breadcrumb />}
            {/* Page content (with padding applied) */}
            <div className="p-6 lg:p-6">
              <Outlet />
            </div>
          </div>
        </main>
      </div>
    </div>
  );
};

export default DashboardLayout;
